import PropTypes from 'prop-types';
import { useEffect, useMemo, useCallback, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'src/routes/hooks';
import { baseURL } from 'src/config-global';
import { endpoints } from 'src/utils/axios';
import { ProfileContext } from './profile-context';
// ----------------------------------------------------------------------
function getCookie(name) {
  let cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    let [ key, value ] = cookie.split('=');
    if (key === name) return value;
  }
  return null;
}
export function ProfileProvider({ children }) {
  const searchParams = useSearchParams();
  const [ userProfile, setUserProfile ] = useState(null);
  const paramsToken = searchParams.get('token') || localStorage.getItem('authToken') || '';
  const token = getCookie('submittals-token') || localStorage.getItem('authToken') || paramsToken || '';
  const project = searchParams.get('project_id') || localStorage.getItem('projectId') || '';
  const company = searchParams.get('company_id') || localStorage.getItem('companyId') || '';

  useEffect(() => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('projectId', project);
    localStorage.setItem('companyId', company);
  }, [ token ]);

  const getProfileInfo = useCallback(() => {
    axios
      .get(`${baseURL}${endpoints.profile_info}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          currentCompanyId: company,
          currentProjectId: project,
        },
      })
      .then((res) => {
        localStorage.getItem('userDetails', JSON.stringify(res.data.payload));
        localStorage.setItem('userId', res.data?.payload?.id);
        if (res.status === 200) {
          setUserProfile(res.data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getProfileInfo();
  }, []);

  // useEffect(() => {
  //   if (
  //     userProfile &&
  //     !userProfile?.permissions.some((perm) => perm.startsWith('submittal_library')) &&
  //     !userProfile?.is_invited
  //   ) {
  //     (async () => {
  //       try {
  //         await postRequest(endpoints.submittals.default_submittals_permission, {}, false);
  //         getProfileInfo();
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     })();
  //   }
  // }, [ userProfile ]);

  const memoizedValue = useMemo(
    () => ({
      userProfile,
      setUserProfile,
      userPermissions: userProfile?.permissions || [],
    }),
    [ userProfile, setUserProfile ]
  );

  return (
    <ProfileContext.Provider value={ memoizedValue }>
      { userProfile ? children : children  }
    </ProfileContext.Provider>
  );
}

ProfileProvider.propTypes = {
  children: PropTypes.node,
};
